import { Grid } from '@mui/material';
import DictionaryTable from './DictionaryTable';
import WordsTable from './WordsTable';
import SuggestedWordsTable from './SuggestedWordsTable';
import { useCustomDictionaryStore } from './store';
import styles from './index.module.css';

const CustomDictionaries = () => {
  const { activeCustomDictionaryId } = useCustomDictionaryStore();

  return (
    <Grid container flexDirection={'column'} className={styles.root}>
      {activeCustomDictionaryId ? (
        <WordsTable />
      ) : (
        <Grid item>
          <SuggestedWordsTable />
          <DictionaryTable />
        </Grid>
      )}
    </Grid>
  );
};

export default CustomDictionaries;
